import { createGlobalStyle } from 'styled-components';
import { Theme } from './theme';

interface GlobalStyleProps {
  theme: Theme;
}

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  /* Reset CSS */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.light};
    background-color: ${({ theme }) => theme.colors.light};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.light};
  }
  
  h1 {
    font-size: ${({ theme }) => theme.fontSizes.xxxlarge};
  }
  
  h2 {
    font-size: ${({ theme }) => theme.fontSizes.xxlarge};
  }
  
  h3 {
    font-size: ${({ theme }) => theme.fontSizes.xlarge};
  }
  
  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
  
  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: ${({ theme }) => theme.transitions.short};
    
    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  button {
    cursor: pointer;
    font-family: ${({ theme }) => theme.fonts.primary};
  }
  
  ul, ol {
    list-style-position: inside;
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
  
  section {
    padding: ${({ theme }) => theme.spacing.xl} 0;
  }
  
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing.md};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    html {
      font-size: 14px;
    }
    
    h1 {
      font-size: ${({ theme }) => theme.fontSizes.xxlarge};
    }
    
    h2 {
      font-size: ${({ theme }) => theme.fontSizes.xlarge};
    }
    
    h3 {
      font-size: ${({ theme }) => theme.fontSizes.large};
    }
  }
`;

export default GlobalStyle; 